import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, tap, throwError } from "rxjs";
import { environment } from "src/environments/environment";


@Injectable({providedIn:'root'})
export class LxcContainerService{
    constructor(private httpClient: HttpClient){}

    createLxc(token:string, body:{}): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        });
        let options = {
            headers: headers,
            responseType: 'text' as 'json' 
        }
        return this.httpClient.post(`${environment.creatoradminApi}user/${token}/lxc/create`, body, options).pipe(
            tap((response: any) => {
                return response
            })
            ,catchError(error=>{
                return throwError(()=>error);
            })
        );
    }
    activateFreeContainer(token:string){
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        });
        let options = {
            headers: headers,
            responseType: 'text' as 'json' 
        }
        return this.httpClient.post(`${environment.creatoradminApi}se2/user/subscriptions/free`,{}, options).pipe(
            tap((response: any) => {
                return response
            })
            ,catchError(error=>{
                return throwError(()=>error);
            })
        );
    }
}
